import React from "react";
import InsertContentsPDF from "./forms/InsertContentsPDF";
import {uploadBookCover, uploadBookFile, chPag, chCha} from "../action/books.js";
import {connect} from "react-redux";

class InsertContentsPagePDF extends React.Component{
    state={
        loading: false
    };
    uploadBookCover = data => {this.setState({loading: true}); this.props.uploadBookCover(data).then(msg => {this.setState({loading:false}); window.location.reload();})};
    uploadBookFile = data => {this.setState({loading: true}); this.props.uploadBookFile(data).then(msg => {this.setState({loading:false});window.location.reload();})};
    chPag = data => {this.setState({loading: true}); this.props.chPag(data).then(msg => {this.setState({loading:false});window.location.reload();})};
    chCha = data => {this.setState({loading: true}); this.props.chCha(data).then(msg => {this.setState({loading:false});window.location.reload();})};
    render(){
        return(
            <div>
                {this.state.loading && (
                    <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    )}
                {this.props.bookId !== undefined && this.props.books &&
                <InsertContentsPDF books={this.props.books[this.props.bookId]} uploadBookCover={this.uploadBookCover} uploadBookFile={this.uploadBookFile} chPag={this.chPag} bookId={this.props.bookId} />}
            </div>
        );
    };
};

function  mapStateToProps(state){
    return {books: state.AllBooks.books}
}

export default connect(mapStateToProps, {uploadBookCover, uploadBookFile, chPag, chCha})(InsertContentsPagePDF);